import React, { Component } from 'react';
import './Footer.css';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import Modal, { ModalClose } from '@acri-tools/react-tools/components/Modal/Modal';
import { GDPR_PATH } from '../../gdpr/setup';


interface Props extends RouteComponentProps {
    // ====== Redux ======
    login?: any
}

interface State {
    modalNotice: boolean
}

class Footer extends Component<Props, State>{
    state = {
        modalNotice: false,
    }

    handleNoticeModal = () => this.setState({ modalNotice: true });

    handleGdpr = () => this.props.history.push(GDPR_PATH);

    render() {
        return (
            !isMobile &&
            <div id="footer">

                {this.state.modalNotice &&
                        <Modal
                        className="medium"
                        opened={this.state.modalNotice}
                        close={() => { this.setState({ modalNotice: false }) }}
                    >
                        <div className="modal-title">
                            Legal Notice | Mentions légales
                            <ModalClose close={() => { this.setState({ modalNotice: false }) }} />
                        </div>
                        <div className="modal-content">
                            <div className="footer-modal-title">Mentions légales</div>

                            <div className="footer-modal-title">Qui sommes-nous</div>
                            <ul>
                                <li>Raison sociale : ACRI-ST</li>
                                <li>Siège social : 260 Route du Pin Montard Sophia-Antipolis 06410 Biot</li>
                                <li>Mail : information@acri-st.fr</li>
                                <li>Téléphone : 04 92 96 75 00</li>
                                <li>Forme juridique : Société par actions simplifiée</li>
                                <li>Montant du capital social : 2 000 000,00 Euros</li>
                                <li>Nom de la présidente : Mme Odile Hembise Fanton d’Andon</li>
                                <li>Nom, dénomination, raison sociale, adresse et numéro de téléphone de l'hébergeur de son site : SAS ACRI-ST, 260 Route du Pin Montard Sophia-Antipolis 06410 Biot, téléphone : 0492967500</li>
                            </ul>

                            <div className="footer-modal-title">Activités</div>
                            <ul>
                                <li>Numéro d'inscription au registre du commerce et des sociétés : 428 834 113 R.C.S. Antibes</li>
                                <li>N° d'identification fiscale : SIREN 428 834 113</li>
                            </ul>

                            <div className="footer-modal-title">Hébergement du site web</div>
                            <ul>
                                <li>Nom de l'hébergeur : ACRI-ST</li>
                                <li>Adresse : 260 Route du Pin Montard Sophia-Antipolis 06410 Biot</li>
                                <li>Téléphone : 04 92 96 75 00</li>
                            </ul>

                            <div className="footer-modal-title footer-modal-lang">Legal Notice</div>

                            <div className="footer-modal-title">Who are we</div>
                            <ul>
                                <li>Company name : ACRI-ST</li>
                                <li>Headquarters : 260 Route du Pin Montard Sophia-Antipolis 06410 Biot</li>
                                <li>Mail : information@acri-st.fr</li>
                                <li>Phone number : 04 92 96 75 00</li>
                                <li>Joint stock company</li>
                                <li>Amount of share capital : 2 000 000,00 Euros</li>
                                <li>Director's name : Mme Odile Hembise Fanton d’Andon</li>
                                <li>Name, denomination, company name, address and telephone number of the host of its site : SAS ACRI-ST, 260 Route du Pin Montard Sophia-Antipolis 06410 Biot, téléphone : 0492967500</li>
                            </ul>

                            <div className="footer-modal-title">Activities</div>
                            <ul>
                                <li>Registration number in the trade and companies register : 428 834 113 R.C.S. Antibes</li>
                                <li>Individual tax identification number : SIREN 428 834 113</li>
                            </ul>

                            <div className="footer-modal-title">Website host</div>
                            <ul>
                                <li>Host name : ACRI-ST</li>
                                <li>Address : 260 Route du Pin Montard Sophia-Antipolis 06410 Biot</li>
                                <li>Phone number : 04 92 96 75 00</li>
                            </ul>
                        </div>
                    </Modal>
                }

                <div className="sub-footer">
                    <div className="rights">
                        <div className="rights-text">
                            © ACRI-ST 2026. All Rights Reserved.
                        </div>
                        <div className="footer-links">
                            <button type="button" className="footer-button" onClick={this.handleNoticeModal}>Legal Notice</button>
                            <button type="button" className="footer-button" onClick={this.handleGdpr}>GDPR</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

const mapStateToProps = (state: any) => {
    return {
        login: state.login
    }
}

export default withRouter(connect(mapStateToProps)(Footer));
